export const getProjectRouteWithTagsParams = (url: string, requiredTagId?: string, tagId?: string, backToId?: string, routeToBack?: string) => {
    const p = new URLSearchParams()
    
    if (requiredTagId) {
        p.set('requiredTagId', requiredTagId)
    }
    if (tagId) {
        p.set('tagId', tagId)
    }
    if (backToId) {
        p.set('backToId', backToId)
    }
    if (routeToBack) {
        p.set('routeBack', routeToBack)
    }
    const qStr = p.toString();

    if (!qStr) {
      return url;
    }
  
    return `${url}?${qStr}`;
}export const getProjectRouteWithTagsParams = (url: string, requiredTagId?: string, tagId?: string, backToId?: string, routeToBack?: string) => {
    const p = new URLSearchParams()
    
    if (requiredTagId) {
        p.set('requiredTagId', requiredTagId)
    }
    if (tagId) {
        p.set('tagId', tagId)
    }
    if (backToId) {
        p.set('backToId', backToId)
    }
    if (routeToBack) {
        p.set('routeBack', routeToBack)
    }
    const qStr = p.toString();

    if (!qStr) {
      return url;
    }
  
    return `${url}?${qStr}`;
}